<template>
  <div class="map-positions-index">
    <div class="map-positions-index__container">
      <div class="map-positions-index__controls">
        <div
          class="map-positions-index__circle left"
          @click="prev"
          :disabled="!hasPrev"
        >
          <svg svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><g mask="url(#b)" fill="#101010"><path d="M4.5 11h17v2h-17z"/><path d="M10.5 6.893L9.107 5.5 2.5 12.107l6.607 6.607L10.5 17.32l-5.214-5.214z"/></g></g></svg>
        </div>
        <div
          class="map-positions-index__circle right"
          @click="next"
          :disabled="!hasNext"
        >
          <svg svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><g mask="url(#b)" fill="#101010"><path d="M19.5 13h-17v-2h17z"/><path d="M13.5 17.107l1.393 1.393 6.607-6.607-6.607-6.607L13.5 6.68l5.214 5.214z"/></g></g></svg>
        </div>
      </div>
      <div class="map-positions-index__cards">
        <template v-if="loadedPositions.data.length > 0">
          <div
            v-for="(position, index) in loadedPositions.data"
            :key="position.id"
            :class="{
              'map-positions-index__card': true,
              'state--visible': isVisible(index)
            }"
          >
            <MapPositionsCardInner :position="position"></MapPositionsCardInner>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import MapPositionsCardInner from "@/components/Home/MapPositionsCardInner";

export default {
  components: {
    MapPositionsCardInner
  },
  data() {
    return {
      items: 4
    };
  },
  computed: {
    homePosition() {
      return this.$store.state.ui.homePosition;
    },
    loadedPositions() {
      return this.$store.state.data.loadedPositions;
    },
    totalIndex() {
      return this.loadedPositions.data.length;
    },
    activeIndex() {
      return this.loadedPositions.data.findIndex(
        x => x.id == this.homePosition.id
      );
    },
    hasPrev() {
      let activeIndex = this.activeIndex;
      return activeIndex > 0;
    },
    hasNext() {
      let activeIndex = this.activeIndex;
      let totalIndex = this.totalIndex - 1;
      return activeIndex < totalIndex;
    },
    visibleIndexes() {
      let totalIndex = this.totalIndex;
      let indexArr = Array.from(Array(totalIndex).keys());
      let items = this.items;
      let searchValue = this.activeIndex;

      var newArr = [];
      indexArr.forEach(function(value) {
        newArr.push({
          index: value,
          difference: Math.abs(value - searchValue)
        });
      });
      newArr.sort((a, b) => a.difference - b.difference);
      newArr = newArr.slice(0, items).map(x => x.index);
      newArr.sort((a, b) => a - b);
      return newArr;
    }
  },
  mounted() {
    let self = this;
    window.addEventListener("resize", function() {
      self.setItems();
    });
    this.setItems();
  },
  methods: {
    setItems() {
      let width = document.documentElement.clientWidth;
      var newItems = 4;
      if (width < 768) {
        newItems = 1;
      }
      this.items = newItems;
    },
    prev() {
      if (this.hasPrev) {
        let newIndex = this.activeIndex - 1;
        this.$store.commit("setHomePosition", this.indexToPosition(newIndex));
      }
    },
    next() {
      if (this.hasNext) {
        let newIndex = this.activeIndex + 1;
        this.$store.commit("setHomePosition", this.indexToPosition(newIndex));
      }
    },
    indexToPosition(index) {
      return this.$store.state.data.loadedPositions.data[index];
    },
    isVisible(index) {
      let visibleIndexes = this.visibleIndexes;
      return visibleIndexes.includes(index);
    }
  }
};
</script>

<style scoped lang="scss">
.map-positions-index {
  bottom: 0;
  height: 300px;
  width: 100%;
  padding: 0 $spacing-4;
  position: relative;
  user-select: none;

  &__cards {
    height: 200px;
    margin-top: auto;
    position: relative;
    width: 100%;
  }

  &__card {
    display: none;
    height: 100%;
    width: 100%;
    position: relative;

    &.state--visible {
      display: inline-block;
    }
  }

  &__container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  &__controls {
    flex: 1;
    display: flex;
    align-items: center;
  }

  &__circle {
    height: 48px;
    width: 48px;
    border: 1px solid $color-gray-1;
    border-radius: 100%;
    background-color: #ffffff;
    position: relative;
    cursor: pointer;

    svg {
      left: 50%;
      top: 50%;
      transform: translate(50%, 50%);
    }

    &.left {
    }
    &.right {
      margin-left: auto;
    }
    &[disabled] {
      cursor: auto;
      opacity: 0.5;

      svg {
        opacity: 0.5;
      }
    }
  }
}

@media (min-width: 768px) {
  .map-positions-index {
    &__container {
      width: 90%;
      margin: 0 auto;
    }
    &__cards {
      width: calc(100% + 16px);
      width: 100%;
    }
    &__card {
      width: 25%;
      padding-left: $spacing-2;
      padding-right: $spacing-2;
    }
  }
}
</style>
